<template>
  <div class="flex-col page">
    <div class="flex-row justify-center self-stretch relative group">
      <img
        @click="$router.back()"
        class="self-center image pos"
        src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=73da474f9f0a9d2a13c183e0f2ed8f88.png"
      />
      <span class="self-start text">视频拍摄</span>
    </div>
    <div class="flex-col justify-start items-center self-center image-wrapper" @click="playOrPause">
      <video
        style="width: 100%;height: 100%;"
        src="/1.mp4"></video>
      <img
        v-show="!playing"
        class="image_2"
        src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=18340cface83549b504e558c91d52e60.png"
      />
    </div>
    <span class="self-start font text_2">最新：2024年学平险保障范围全面扩大</span>
    <div class="flex-row self-stretch group_2">
      <div class="flex-col justify-start items-center text-wrapper"><span class="text_3">保险科普</span></div>
      <span class="self-start text_4 ml-15">时长：1:05</span>
    </div>
    <div class="flex-col self-stretch group_3">
      <div class="flex-col section">
        <div class="flex-row justify-between group_4">
          <span class="self-start font text_5">脚本内容</span>
          <div class="flex-row self-center group_5">
            <img
              class="shrink-0 image_3"
              src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=96b1e7003677605b34b6fedfa8a445c3.png"
            />
            <span class="self-start font_2 text_6 ml-3" @click="alert('复制成功')">复制</span>
          </div>
        </div>
        <div class="flex-col group_6">
          <span class="self-stretch font_2 text_7 mt-3">
            宝爸宝妈们，好消息来啦！2024年学平险保障范围全面扩大啦！
            <br />
          </span>
          <span class="self-start font_2 text_7 mt-3">
            孩子上学，安全和健康是头等大事。学平险一直是家长们为孩子保驾护航的“小能手”，如今它变得更强大了！
            <br />
          </span>
          <span class="self-start font_2 text_7 mt-3">
            今年的学平险不仅涵盖了意外伤害、疾病医疗等常见保障，还新增了许多实用的保障内容。比如，一些产品增加了校园内意外事故的赔付范围，甚至对一些特殊疾病也有了更全面的保障。无论是小磕小碰，还是突发疾病，都能给孩子更贴心的守护。
            <br />
          </span>
          <span class="self-start font_2 text_7 mt-3">
            更让人惊喜的是，保障升级的同时，保费并没有大幅增加，性价比超高！这对于家长们来说，无疑是最大的福音。
            <br />
          </span>
          <span class="self-start font_2 text_7 mt-3">
            孩子的成长路上，风险处无不在。2024年学平险的升级，就像给孩子的校园生活加了一道“安全锁”。家长们，赶紧了解一下，为孩子选择一份更全面的保障吧！
          </span>
        </div>
      </div>
      <div class="flex-row relative group_7">
        <div class="flex-col justify-start items-center shrink-0 text-wrapper_2" @click="$router.push('/xiugaijiaoben')"><span class="font_3">修改</span></div>
        <div class="flex-col justify-start items-center flex-1 text-wrapper_3 ml-13" @click="$router.push('/shipinpaishe')">
          <span class="font_3 text_11">开始拍摄</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {},
    data() {
      return {
        playing: false,
      };
    },

    methods: {
      alert() {
        window.alert('复制成功')
      },
      playOrPause() {
        const video = document.querySelector('video');
        if (video.paused) {
          video.play();
          this.playing = true;
        } else {
          video.pause();
          this.playing = false;
        }
      },
    },
  };
</script>

<style scoped lang="less">
  .ml-15 {
    margin-left: 15px;
  }
  .ml-3 {
    margin-left: 3px;
  }
  .mt-3 {
    margin-top: 3px;
  }
  .ml-13 {
    margin-left: 13px;
  }
  .page {
    padding: 0 16px 43px;
    background-color: rgb(17, 17, 17);
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    .group {
      padding: 14px 0 22px;
      .image {
        border-radius: 5px;
        width: 24px;
        height: 24px;
      }
      .pos {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      .text {
        color: rgb(255, 255, 255);
        font-size: 18px;
        font-family: 思源黑体;
        font-weight: 700;
        line-height: 17px;
      }
    }
    .image-wrapper {
      background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=55e3f3c188aebc7a95d72f4f80e90470.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 165px;
      position: relative;
      .image_2 {
        position: absolute;
        top: 40%;
        border-radius: 50%;
        width: 40px;
        height: 40px;
      }
    }
    .font {
      font-size: 16px;
      font-family: 思源黑体;
      line-height: 15px;
    }
    .text_2 {
      margin-left: 12px;
      margin-top: 14px;
      color: rgba(255, 255, 255, 0.8);
      font-size: 18px;
    }
    .group_2 {
      margin-top: 10px;
      padding: 0 12px;
      .text-wrapper {
        padding: 4px 0 8px;
        background-color: rgb(85, 239, 227);
        border-radius: 8px;
        width: 64px;
        height: 24px;
        .text_3 {
          color: rgb(17, 17, 17);
          font-size: 12px;
          font-family: Barlow;
          line-height: 11px;
          margin-top: 2px;
        }
      }
      .text_4 {
        margin-top: 6px;
        color: rgba(255, 255, 255, 0.5);
        font-size: 12px;
        font-family: 思源黑体;
        line-height: 11px;
      }
    }
    .group_3 {
      margin-top: 10px;
      height: 410px;
      .section {
        margin: 0 12px;
        padding: 0 13px 14px;
        background-color: rgba(108, 108, 108, 0.5);
        border-radius: 20px;
        .group_4 {
          padding: 20px 0 10px;
          .text_5 {
            color: rgb(255, 255, 255);
            font-weight: 700;
            line-height: 15px;
          }
          .group_5 {
            margin-right: 7px;
            .image_3 {
              width: 20px;
              height: 20px;
            }
            .text_6 {
              color: rgb(128, 128, 128);
              line-height: 13px;
            }
          }
        }
        .group_6 {
          overflow: hidden;
          height: 316px;
          .text_7 {
            width: 328px;
          }
          .text_8 {
            width: 321px;
          }
          .text_9 {
            width: 320.5px;
          }
          .text_10 {
            margin-bottom: -20px;
            width: 321px;
          }
        }
        .font_2 {
          font-size: 14px;
          font-family: 思源黑体;
          line-height: 17px;
          color: rgb(249, 249, 249);
        }
      }
      .group_7 {
        margin-top: -11px;
        .text-wrapper_2 {
          padding: 12px 0 18px;
          background-color: rgb(85, 239, 227);
          border-radius: 16px;
          overflow: hidden;
          width: 108px;
          height: 50px;
        }
        .text-wrapper_3 {
          margin-right: 12px;
          padding: 12px 0 18px;
          background-color: rgb(85, 239, 227);
          border-radius: 16px;
          overflow: hidden;
          height: 50px;
          .text_11 {
            letter-spacing: 2px;
          }
        }
        .font_3 {
          font-size: 22px;
          font-family: Barlow;
          line-height: 20.5px;
          font-weight: 600;
          color: rgb(17, 17, 17);
        }
      }
    }
  }
</style>
